import { useSelectField } from '@zurich/common/hooks';
import { Select } from '@zurich/ui/legacy/components';
import { type AutoArea, vehiclePartOptions } from '~/lib/types';
import {
  areaOfDamageFieldSelectorFamily,
  damagedPartValidationSelectorFamily,
} from '~/state';

export function DamagedPartSelect({
  id,
  step,
}: {
  id: string;
  step: AutoArea;
}) {
  const damagedPartProps = useSelectField({
    atom: areaOfDamageFieldSelectorFamily({
      id,
    }),
    validationSelector: damagedPartValidationSelectorFamily(id),
    fieldName: 'vehiclePart',
    i18nPrefix: 'vsga:fields.',
    required: true,
  });

  return (
    <Select
      {...damagedPartProps}
      data-name="damage-area"
      options={vehiclePartOptions[step]}
    />
  );
}
